import router from "./router";
import store from "./store";
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css"; // Progress 进度条样式
import {
  Message
} from "element-ui";
import {
  getToken,
  setSupplierId,
  setPharmacyId,
  setSupplierAgentId,
  setIsSupplierAgentLogin,
  setOutPharmacyId,
  setHospitalPartnerId,
  setIsSupplierLogin,
  setIsPlatLogin,
  setSubsidiaryId,
  setIsSubsidiaryLogin,
  setIsPharmacyLogin,
  setIsProducterLogin,
  setIsOutPharmacyLogin,
  setIsAdminLogin,
  setAuthFinanceAccountIds,
  setIsSpecialPharmacyLogin
} from "@/utils/auth"; // 验权

const whiteList = ["/login"]; // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (getToken()) {
    if (to.path === "/login") {
      next({
        path: "/"
      });
      NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        store
          .dispatch("GetInfo")
          .then(res => {
            // 拉取用户信息
            console.log(res, "----GetInfo------")
            if (res.data.authFinanceAccountIds == null) {
              setAuthFinanceAccountIds('')
            } else {
              setAuthFinanceAccountIds(res.data.authFinanceAccountIds)
            }
            let menus = res.data.menus;
            let username = res.data.username;
            if(username.indexOf('南昌五味堂') >= 0 || username.indexOf('test中药药房') >= 0){
              setIsSpecialPharmacyLogin(1)
            }else{
              setIsSpecialPharmacyLogin(0)
            }
            if (res.data.roleName == "供应商管理员") {
              //保存id
              setSupplierId(res.data.supplierId);
              setIsSupplierLogin(1);
            } else {
              setIsSupplierLogin(0);
            }
            if (res.data.roleName == "平台管理员") {
              setIsPlatLogin(1);
            } else {
              setIsPlatLogin(0);
            }
            if (res.data.roleName == "超级管理员") {
              setIsAdminLogin(1);
            } else {
              setIsAdminLogin(0);
            }
            if (res.data.roleName == "药店管理员" || res.data.roleName == "中药药房") {
              setPharmacyId(res.data.pharmacyId);
              setIsPharmacyLogin(1)
            } else {
              setIsPharmacyLogin(0)
            }

            if (res.data.roleName == "产品总代") {
              setSupplierAgentId(res.data.supplierAgentId);
              setIsSupplierAgentLogin(1)
            } else {
              setIsSupplierAgentLogin(0)
            }


            if (res.data.roleName == "院外药房") {
              setOutPharmacyId(res.data.outPharmacyId);
              setIsOutPharmacyLogin(1)
            } else {
              setIsOutPharmacyLogin(0)
            }
            if (res.data.hospitalPartnerId != null) {
              setHospitalPartnerId(res.data.hospitalPartnerId);
            }
            if (res.data.roleName == "产品管理员") {
              setIsProducterLogin(1)
            } else {
              setIsProducterLogin(0)
            }
            if (res.data.roleName == "平台分公司") {
              setIsSubsidiaryLogin(1)
            } else {
              setIsSubsidiaryLogin(0)
            }
            if (res.data.subsidiaryId != null) {
              setSubsidiaryId(res.data.subsidiaryId);
            } else {
              setSubsidiaryId('');
            }
            store.dispatch("GenerateRoutes", {
              menus,
              username
            }).then(() => {
              // 生成可访问的路由表
              router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
              next({
                ...to,
                replace: true
              });
            });
          })
          .catch(err => {
            store.dispatch("FedLogOut").then(() => {
              Message.error(err || "Verification failed, please login again");
              next({
                path: "/"
              });
            });
          });
      } else {
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next("/login");
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});



// WEBPACK FOOTER //
// ./src/permission.js